<template>
    <div class="wh100">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item v-if="goodsShipVoucher.ioFlag == 1">发货单</el-breadcrumb-item>
                <el-breadcrumb-item v-if="goodsShipVoucher.ioFlag == -1 && goodsShipVoucher.deliverType == 0">换货收货单</el-breadcrumb-item>
                <el-breadcrumb-item v-if="goodsShipVoucher.ioFlag == -1 && goodsShipVoucher.deliverType == -1">退货收货单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="block-container">
            <div class="content-caption dashed bg-white">
                <span>卖家信息</span>
            </div>
            <div class="block-container">
                <div class="form-single mt20 mb20">
                    <table class="custom-tbl">
                        <thead class="head">
                        <tr class="row align-left">
                            <th class="align-left">卖家名称</th>
                            <th style="width: 200px">发货人</th>
                            <th style="width: 200px">发货人联系方式</th>
                        </tr>
                        </thead>
                        <tbody class="body">
                        <tr class="row align-left">
                            <td class="align-left ellipsis" :title="goodsShipVoucher.sellerName">{{goodsShipVoucher.sellerName}}</td>
                            <td style="width: 200px">{{goodsShipVoucher.senderContactName}}</td>
                            <td style="width: 200px">{{goodsShipVoucher.senderContactTel}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="content-caption dashed bg-white">
                <span>机构信息</span>
            </div>
            <div class="block-container">
                <div class="form-single mt20 mb20">
                    <table class="custom-tbl">
                        <thead class="head">
                        <tr class="row align-left">
                            <th style="width: 200px; text-align: left">业务单元</th>
                            <th style="width: 200px; text-align: left">所属部门</th>
                            <th v-if="goodsShipVoucher.ioFlag == 1">收货地址</th>
                            <th v-if="goodsShipVoucher.ioFlag == -1">发货地址</th>
                            <th style="width: 200px">联系人</th>
                            <th style="width: 200px">联系方式</th>
                        </tr>
                        </thead>
                        <tbody class="body">
                        <tr class="row align-left">
                            <td style="width: 200px; text-align: left" class="ellipsis" :title="goodsShipVoucher.buyerShopName">{{goodsShipVoucher.buyerShopName}}</td>
                            <td style="width: 200px; text-align: left" class="ellipsis" :title="goodsShipVoucher.buyerBizUnitName">{{goodsShipVoucher.buyerBizUnitName}}</td>
                            <td class="ellipsis" :title="goodsShipVoucher.buyerRecvAddr">{{goodsShipVoucher.buyerRecvAddr}}</td>
                            <td style="width: 200px">{{goodsShipVoucher.buyerRecvContractName}}</td>
                            <td style="width: 200px">{{goodsShipVoucher.buyerRecvContactTel}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="content-caption dashed bg-white">
                <span>商品信息</span>
            </div>

            <div class="block-container">
                <el-form :model="goodsShipVoucher" ref="goods">
                    <el-table :data="goodsShipVoucher.itemList" border style="width: 100%">
                        <el-table-column align="left" prop="title" label="商品名称"></el-table-column>
                        <el-table-column align="left" width="200" prop="brandName" label="品牌名称"></el-table-column>
                        <el-table-column align="center" width="120" prop="asmblFlag" label="提供商品标识码">
                            <template slot-scope="rows">
                                <span v-if="rows.row.vendorUknoFlag">是</span>
                                <span v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100" prop="price" label="含税价(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.price != null">{{rows.row.price.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100" prop="taxRate" label="税率(%)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.taxRate != null">{{rows.row.taxRate.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100" prop="ntxPrice" label="未税价(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.ntxPrice != null">{{rows.row.ntxPrice.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="120" prop="amount" label="费用小计(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.amount != null">{{rows.row.amount.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="120" prop="ntxAmount" label="未税小计(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.ntxAmount != null">{{rows.row.ntxAmount.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="goodsShipVoucher.ioFlag == 1" align="right" width="120" prop="quantity" label="发货数量"></el-table-column>
                        <el-table-column v-if="goodsShipVoucher.ioFlag == -1" align="right" width="120" prop="quantity" label="收货数量"></el-table-column>
                        <el-table-column v-if="warehouseId != null" align="right" width="120" prop="stockQuantity" label="库存数量">
                            <template slot-scope="rows">
                                <span v-if="rows.row.stockQuantity == null" style="color: red;" title="仓库中没有此商品">无</span>
                                <span v-else>{{rows.row.stockQuantity}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" prop="desc" label="说明"></el-table-column>
                        <el-table-column v-if="goodsShipVoucher.ioFlag == 1 && goodsShipVoucher.receiveState == 0 && goodsShipVoucher.invalid == 0" width="100" label="操作">
                            <template slot-scope="rows">
                                <i class="swb-btn-link" @click="shipVoucherOffset(rows.row)">冲红</i>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>

            <div v-if="goodsShipVoucher.shipProxied">
                <div class="content-caption dashed bg-white">
                    <span>委托发货</span>
                </div>
                <div class="form-row">
                    <div class="form-label">
                        <label>委托发货方</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-input class="width-1-5x bottom-line" :disabled="true" v-model="goodsShipVoucher.shipperName"></el-input>
                    </div>
                </div>
            </div>

            <div class="content-caption dashed bg-white">
                <span>物流信息</span>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">预计到货日期</div>
                <div class="content">
                    <span>{{goodsShipVoucher.expectArriveDate || '无'}}</span>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">公司名称</div>
                <div class="content">
                    <div class="pos-rel" style="width: 225px">
                        <el-input class="width-1-5x bottom-line" :disabled="true" v-model="goodsShipVoucher.logisComName"></el-input>
                    </div>
                </div>
            </div>
            <div class="form-single mt20 mb20" v-if="goodsShipVoucher.ioFlag == 1">
                <div class="title">公司代码</div>
                <div class="content">
                    <div class="pos-rel" style="width: 225px">
                        <el-input class="width-1-5x bottom-line" :disabled="true" v-model="goodsShipVoucher.logisComCode"></el-input>
                    </div>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">物流单号</div>
                <div class="content">
                    <div class="pos-rel" style="width: 225px">
                        <el-input class="width-1-5x bottom-line" :disabled="true" v-model="goodsShipVoucher.logisExpNo"></el-input>
                    </div>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">物流费用(元)</div>
                <div class="content">
                    <div class="pos-rel" style="width: 225px">
                        <el-input class="width-1-5x bottom-line" :disabled="true" v-model="goodsShipVoucher.logisFee"></el-input>
                    </div>
                </div>
            </div>

            <div class="content-caption dashed bg-white" v-if="goodsShipVoucher.exceptional">
                <span>异常描述</span>
            </div>
            <div class="form-single mt20 mb20" v-if="goodsShipVoucher.exceptional">
                <div class="">
                    <div class="pos-rel" style="width: 225px">
                        <label>{{goodsShipVoucher.exceptionDesc}}</label>
                    </div>
                </div>
            </div>

            <div v-if="type == 'confirmedShip'">
                <div class="content-caption dashed bg-white">
                    <span>出库仓库</span>
                </div>
                <div class="form-single">
                    <div class="title required" style="width: 90px;">出库仓库</div>
                    <div class="content" style="padding-left: 100px">
                        <el-select v-model="warehouseId" placeholder="请选择" @change="compareIn">
                            <el-option v-for="item in warehouseList" :key="item.name" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import goodsDelivApi from '../../api/goodsDeliv'
    import goodsStockApi from '../../api/goodsStock'

    export default {
        name: 'swb-goods-ship-voucher-info',
        desc: '发货/收货单详情',
        props: {
            id: {},
            type: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                goodsShipVoucher: {},
                warehouseId: null,
                warehouseList: [],
                stockQuantityFlag: true
            }
        },
        created: function () {
            this.getGoodsShipVoucher();
            //
            if(this.type == 'confirmedShip') {
                this.getWarehouseList();
            }
        },
        methods: {
            compareIn(val){
                // 仓库更换
                this.getGoodsShipVoucher();
            },
            // 获取仓库信息
            getWarehouseList: function () {
                let self = this;
                let postData = {};
                let filterItems = {};
                filterItems.type = getEnumInfoWith('warehouseType', 'name', "GoodsWarehouse").value;    // 商品仓库
                filterItems.locked = false;
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                goodsStockApi.getWarehouseList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        //
                        self.warehouseList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 收/发货单详情
            getGoodsShipVoucher: function () {
                let self = this;
                let params = {};
                params.id = self.id;
                if(!Utils.isNoB(self.warehouseId)) {
                    params.warehouseId = self.warehouseId;
                }
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsShipVoucherInfo(params, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        self.goodsShipVoucher = result.data;
                        if(!Utils.isNoB(self.warehouseId)) {
                            let itemList = self.goodsShipVoucher.itemList;
                            if(!Utils.isNoB(itemList)) {
                                let stockQuantityFlag = true;
                                itemList.forEach(function (item) {
                                    if(item.stockQuantity == null) {
                                        stockQuantityFlag = false;
                                    }
                                });
                                self.stockQuantityFlag = stockQuantityFlag;
                            }
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            shipVoucherOffset: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '冲红 - 设置',
                    showCloseBtn: true,
                    width: 530,
                    height: 300,
                    template: '<div>' +
                    '<div class="hint block mt5 mb5">' +
                    '<span class="mr20">发货数量 : {{quantity}}</span><span>已冲红数量 : {{offsetQuantity}}</span>' +
                    '</div>' +
                    '<div class="form-info">' +
                    '<div class="form-row">' +
                    '<div class="form-label"><label>冲红数量</label></div>' +
                    '<div class="form-value width-1-5x">' +
                    '<el-input type="number" v-model.number="offset" min="0"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        quantity: row.quantity,
                        offsetQuantity: row.offsetQuantity,
                        offset: 0,
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        if(!Utils.isNaturalStr(selfDlg.offset, true)) {
                            MsgBox.warning("总冲红数量不能为负数");
                            return false;
                        } else if(parseInt(selfDlg.offset) + parseInt(selfDlg.offsetQuantity) > parseInt(selfDlg.quantity)) {
                            MsgBox.warning("总冲红数量不能大于发货数量");
                            return false;
                        }
                        let postData = {};
                        postData.id = row.id;
                        postData.offsetQuantity = selfDlg.offset;
                        let lastMsgBoxDlg = MsgBox.loading();
                        goodsDelivApi.shipVoucherOffset(postData, function (result) {
                            lastMsgBoxDlg.close();
                            if(result.type === "info") {
                                self.getGoodsShipVoucher();
                                MsgBox.success('设置成功!');
                            } else {
                                MsgBox.warning(result.message);
                            }
                        })

                    },
                    lifecycle: {}
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsShipVoucherInfo.vue